import React, { useState } from "react";
import "./AdminModel.css";
import ESAPManager from "./ESAPManager";
import KbManage from "./KbManage";
import LendersQA from "./LendersQA";
import ReportsVault from "./ReportsVault";
import TeamManagement from "./TeamManagment";

const tabs = [
  "Team",
  "Knowledge Base",
  "Reports",
  "Dynamic ESAP",
  "Lender Q&A",
];

const AdminModel = ({
  onClose,
  userEmail,
  switchTeams,
  fullTeam,
  filesForApproval,
  lastSynced,
  handleSyncFiles,
  handleCheckSyncStatus,
  filenames,
  handleDeleteFile,
  selectedTeamId,
  teamStorageUsage,
  currentTeamName,
}) => {
  const [activeTab, setActiveTab] = useState("Team");

  const renderContent = () => {
    switch (activeTab) {
      case "Team":
        return (
          <TeamManagement userEmail={userEmail} switchTeams={switchTeams} currentTeamName={currentTeamName} />
        );
      case "Knowledge Base":
        return (
          <KbManage
            userEmail={userEmail}
            filesForApproval={filesForApproval}
            fullTeam={fullTeam}
            lastSynced={lastSynced}
            handleSyncFiles={handleSyncFiles}
            handleCheckSyncStatus={handleCheckSyncStatus}
            filenames={filenames}
            handleDeleteFile={handleDeleteFile}
            selectedTeamId={selectedTeamId}
            teamStorageUsage={teamStorageUsage}
          />
        );
      case "Reports":
        return <ReportsVault selectedTeamId={selectedTeamId} />;
      case "Dynamic ESAP":
        return <ESAPManager selectedTeamId={selectedTeamId} userEmail={userEmail} filenames={filenames} />;
      case "Lender Q&A":
        return <LendersQA userEmail={userEmail} selectedTeamId={selectedTeamId} filenames={filenames} />;
      default:
        return null;
    }
  };

  return (
    <div className="cc-overlay">
      <div className="cc-container">
        {/* Header */}
        <div className="cc-header">
          <h2>Command Centre</h2>
          <button onClick={onClose}>✕</button>
        </div>

        {/* Body */}
        <div className="cc-body">
          {/* Sidebar */}
          <div className="cc-sidebar">
            {tabs.map((tab) => (
              <div
                key={tab}
                className={`cc-tab ${activeTab === tab ? "active" : ""}`}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </div>
            ))}
          </div>

          {/* Content */}
          <div className="cc-content">{renderContent()}</div>
        </div>
      </div>
    </div>
  );
};

export default AdminModel;
